<template>
  <zt-modal max-width="450px" :show-button-close="false" class="rounded" :active="activeSign"
    @close="$emit('close-sign-modal')">
    <template slot="modal-header">
      <div class="w-full">
        <p class="p-4 text-zt-lg font-medium text-white">
          {{

            $t(
              'message.documentVisualizerComponent.signDialog.signConfort'
            )

          }}
        </p>
      </div>
    </template>
    <div class="px-4 pb-4">

      <ValidationObserver v-slot="{ handleSubmit }">
        <v-form id="sign-document-form" @submit.prevent="handleSubmit(signDocument)" ref="notConfortReasonForm">

          <div>
            <p class="py-4 confirm--label">
              {{
                $t(
                  'message.documentVisualizerComponent.signDialog.inputPassword'
                )
              }}
            </p>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <zt-input data-vs-input="password" type="password" outlined
                :label="$t('message.loginComponent.languagesVuetify.password')" v-model="userPass"
                :color="invalid ? 'danger' : 'primary'" />
              <span v-show="errors[0]" class="text-zt-danger">{{
                $t("message.loginComponent.validations.passwordRules.requirePass") }}</span>
            </ValidationProvider>
          </div>

        </v-form>
      </ValidationObserver>
    </div>
    <template slot="modal-footer">
      <div class="zt-modal-footer flex justify-end items-center p-4 confirm--footer">
        <zt-button class="mr-1" outlined @click="$emit('close-sign-modal')">{{ $t("message.DownloadAllDocuments.cancel")
          }}</zt-button>
        <zt-button data-vs-button="submit" :disabled="disabledSend" @click="signDocument" form="sign-document-form"
          class="ml-1">{{
            $t('message.documentComponent.SignedDocuments.sendDocument')
          }}</zt-button>
      </div>
    </template>
  </zt-modal>
</template>
<script>
import Users from '@/apiClient/Users'
export default {
  name: 'SignModal',
  props: {
    activeSign: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: true
    },
    hasVP: {
      type: Boolean,
      required: true
    },
    updateFn: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      isLoading: false,
      disabledSend: false,
      userPass: '',
      invalid: false
    }
  },
  mounted() {
    this.userApi = new Users()
    this.isLoading = false
  },
  methods: {
    async signDocument() {
      const body = {
        street: this.params.street,
        number: this.params.number,
        flat: this.params.flat,
        department: this.params.department,
        neighborhood: this.params.neighborhood,
        block: this.params.block,
        passphrase: this.userPass,
      }
      if (this.hasVP) {
        body.idCountry = this.params.idCountry.id,
          body.idState = this.params.idState.id,
          body.idCity = this.params.idCity.id,
          body.state = this.params.idState.description;
        body.city = this.params.idCity.description
        body.country = this.params.idCountry.description;
      }
      else {
        body.state = this.params.state;
        body.city = this.params.city;
        body.country = this.params.country;
      }
      if (body.id) delete body.id
      if ('sichernpeople' in body) delete body.sichernpeople
      try {
        this.disabledSend = true
        await this.userApi.saveAddressInfo(body)
        this.userPass = ''
        await this.updateFn()
        this.disabledSend = false
        this.$emit('close-sign-modal')
        await this.$swal({
          type: 'success',
          title: this.$t('message.selfService.response.success'),
          timer: this.$store.getters.getTimerSweetAlert,
          showConfirmButton: false
        })
      } catch (e) {
        const code = e.response.data.codes[0].code
        this.disabledSend = false
        this.$swal({
          type: 'error',
          title: this.$t(
            `message.selfService.response.errors.${code}`
          ),
          showConfirmButton: true,
          confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
        })
      }
    },
  },
  computed: {
    userEmail() {
      return this.$store.getters.getUserEmail;
    }
  },

}
</script>